module.exports = __webpack_public_path__ + "static/blue-rocket@2x-42c0d6d6aab99d0fb885dc44b2cb9e67.png";